import './basket-list.scss';
import { FCC } from '../../../../../utils/types';

interface Props {
  title?: string;
}
const BasketList: FCC<Props> = ({ children, title }) => (
  <>
    {title && <h3 className="basket-list-title button-or-bold">{title}</h3>}

    <ul className="basket-list">{children}</ul>
  </>
);

export default BasketList;
